import { http } from 'utils'
import { SET_ITEMS } from 'vx/mutations'

export default {
  namespaced: true,

  state: {
    labels: [],
    meta: null
  },

  actions: {
    async getLabels ({ commit, state }, { params = {} } = {}) {
      const response = await http.get('print-history', { params })

      commit(SET_ITEMS, response.data.data)

      return response
    },

    resetRequests ({ commit }) {
      commit(SET_ITEMS, [])
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.labels = items
    }
  }
}
